import { render, staticRenderFns } from "./ss-recmd-list.vue?vue&type=template&id=06b086b2&scoped=true&"
import script from "./ss-recmd-list.vue?vue&type=script&lang=js&"
export * from "./ss-recmd-list.vue?vue&type=script&lang=js&"
import style0 from "./ss-recmd-list.vue?vue&type=style&index=0&id=06b086b2&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b086b2",
  null
  
)

export default component.exports